'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002e$002dProduct21 from "./scala.-Product21.js";
var $p;
/** @constructor */
function $c_T21(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21) {
  this.p3 = null;
  this.pe = null;
  this.ph = null;
  this.pi = null;
  this.pj = null;
  this.pk = null;
  this.pl = null;
  this.pm = null;
  this.pn = null;
  this.p4 = null;
  this.p5 = null;
  this.p6 = null;
  this.p7 = null;
  this.p8 = null;
  this.p9 = null;
  this.pa = null;
  this.pb = null;
  this.pc = null;
  this.pd = null;
  this.pf = null;
  this.pg = null;
  this.p3 = _1;
  this.pe = _2;
  this.ph = _3;
  this.pi = _4;
  this.pj = _5;
  this.pk = _6;
  this.pl = _7;
  this.pm = _8;
  this.pn = _9;
  this.p4 = _10;
  this.p5 = _11;
  this.p6 = _12;
  this.p7 = _13;
  this.p8 = _14;
  this.p9 = _15;
  this.pa = _16;
  this.pb = _17;
  this.pc = _18;
  this.pd = _19;
  this.pf = _20;
  this.pg = _21;
}
export { $c_T21 as $c_T21 };
$p = $c_T21.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_T21;
/** @constructor */
function $h_T21() {
}
export { $h_T21 as $h_T21 };
$h_T21.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.n = (function() {
  return 21;
});
$p.g = (function(n) {
  return $j_scala$002e$002dProduct21.$f_s_Product21__productElement__I__O(this, n);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().av(this, (-21288119), true);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_T21) && (((((((((((((((((((($j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.p3, x$0.p3) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pe, x$0.pe)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.ph, x$0.ph)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pi, x$0.pi)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pj, x$0.pj)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pk, x$0.pk)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pl, x$0.pl)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pm, x$0.pm)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pn, x$0.pn)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.p4, x$0.p4)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.p5, x$0.p5)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.p6, x$0.p6)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.p7, x$0.p7)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.p8, x$0.p8)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.p9, x$0.p9)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pa, x$0.pa)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pb, x$0.pb)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pc, x$0.pc)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pd, x$0.pd)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pf, x$0.pf)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pg, x$0.pg))));
});
$p.o = (function() {
  return "Tuple21";
});
$p.b = (function() {
  return (((((((((((((((((((((((((((((((((((((((((("(" + this.p3) + ",") + this.pe) + ",") + this.ph) + ",") + this.pi) + ",") + this.pj) + ",") + this.pk) + ",") + this.pl) + ",") + this.pm) + ",") + this.pn) + ",") + this.p4) + ",") + this.p5) + ",") + this.p6) + ",") + this.p7) + ",") + this.p8) + ",") + this.p9) + ",") + this.pa) + ",") + this.pb) + ",") + this.pc) + ",") + this.pd) + ",") + this.pf) + ",") + this.pg) + ")");
});
function $isArrayOf_T21(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eL)));
}
export { $isArrayOf_T21 as $isArrayOf_T21 };
var $d_T21 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_T21, "scala.Tuple21", ({
  eL: 1,
  b: 1,
  c: 1,
  rU: 1,
  a: 1
}));
export { $d_T21 as $d_T21 };
